import { type ResponseItemType } from '@/common/types/response.type';
import { useQuery } from '@tanstack/react-query';
import Client from '@/common/utils/client.utility';

interface IHelpAndSupport {
  supportTimeWorkingDays: string;
  supportTimeHolidays: string;
  isFulltimeHelpAndSupportEnabled: boolean;
}
type GetConfigType = () => Promise<ResponseItemType<IHelpAndSupport>>;

const getHelpAndSupportService: GetConfigType = async () => {
  const client = new Client();
  return await client.get(`/v1/personalpage/Shopper/HelpAndSupport`);
};

export function useGetHelpAndSupport({
  enabled = true,
}: {
  enabled?: boolean;
}) {
  return useQuery({
    queryKey: ['Help-And-Support'],
    queryFn: getHelpAndSupportService,
    enabled,
  });
}
